import React from "react";
import "./NotFoundPage.css";

export default function NotFoundPage() {
  return (
    <section className="notFoundPage sect">
      <h1>404- PAGE NOT FOUND</h1>
    </section>
  );
}
